import iconThemeColor from "../index";

const MailIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 5.5C4.39543 5.5 3.5 6.39543 3.5 7.5V16.5C3.5 17.6046 4.39543 18.5 5.5 18.5H18.5C19.6046 18.5 20.5 17.6046 20.5 16.5V7.5C20.5 6.39543 19.6046 5.5 18.5 5.5H5.5ZM5.34454 6.51201C5.3952 6.5041 5.44712 6.5 5.5 6.5H18.5C18.5529 6.5 18.6048 6.50411 18.6555 6.51202L12.6585 11.7594C12.2815 12.0893 11.7185 12.0893 11.3415 11.7594L5.34454 6.51201ZM4.56103 7.15521C4.52155 7.26269 4.5 7.37883 4.5 7.5V16.5C4.5 17.0523 4.94772 17.5 5.5 17.5H18.5C19.0523 17.5 19.5 17.0523 19.5 16.5V7.5C19.5 7.37884 19.4785 7.26272 19.439 7.15525L13.317 12.5119C12.563 13.1717 11.4371 13.1717 10.683 12.5119L4.56103 7.15521Z"
        fill={fillColor}
      />
    </svg>
  );
};

const CheckIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3427 6.6359C19.5438 6.82516 19.5534 7.1416 19.3641 7.34268L11.3641 15.8427C11.1797 16.0386 10.8733 16.0535 10.6708 15.8763L6.67075 12.3763C6.46294 12.1944 6.44188 11.8786 6.62372 11.6707C6.80556 11.4629 7.12144 11.4419 7.32926 11.6237L10.9664 14.8062L18.6359 6.65732C18.8252 6.45623 19.1416 6.44664 19.3427 6.6359Z"
        fill={fillColor}
      />
    </svg>
  );
};

const InfoIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.5098 8.57617C11.474 8.66406 11.4561 8.76009 11.4561 8.86426C11.4561 8.96842 11.474 9.06608 11.5098 9.15723C11.5489 9.24512 11.6026 9.31999 11.671 9.38184C11.7393 9.44694 11.8207 9.4974 11.9151 9.5332C12.0128 9.56901 12.1202 9.58691 12.2374 9.58691C12.4783 9.58691 12.6687 9.52018 12.8087 9.38672C12.9519 9.25 13.0235 9.07585 13.0235 8.86426C13.0235 8.65267 12.9519 8.48014 12.8087 8.34668C12.6687 8.20996 12.4783 8.1416 12.2374 8.1416C12.1202 8.1416 12.0128 8.15951 11.9151 8.19531C11.8207 8.23112 11.7393 8.27995 11.671 8.3418C11.6026 8.4069 11.5489 8.48503 11.5098 8.57617Z"
        fill={fillColor}
      />
      <path
        d="M11.0542 10.2168C10.7481 10.2168 10.5 10.4649 10.5 10.771C10.5 11.0771 10.7481 11.3252 11.0542 11.3252H11.5538V15.814C11.5538 16.1929 11.8609 16.5 12.2398 16.5C12.6187 16.5 12.9259 16.1929 12.9259 15.814V10.7168C12.9259 10.4407 12.702 10.2168 12.4259 10.2168H11.0542Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12Z"
        fill={fillColor}
      />
    </svg>
  );
};

const FlagIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 4.5H10.7639C10.9968 4.5 11.2265 4.55422 11.4348 4.65836L13.0125 5.44721C13.0819 5.48193 13.1584 5.5 13.2361 5.5H16C16.8284 5.5 17.5 6.17157 17.5 7V12C17.5 12.8284 16.8284 13.5 16 13.5H13.2361C13.0032 13.5 12.7735 13.4458 12.5652 13.3416L10.9875 12.5528C10.9181 12.5181 10.8416 12.5 10.7639 12.5H7.5V19C7.5 19.2761 7.27614 19.5 7 19.5C6.72386 19.5 6.5 19.2761 6.5 19V5C6.5 4.72386 6.72386 4.5 7 4.5ZM7.5 5.5V11.5H10.7639C10.9968 11.5 11.2265 11.5542 11.4348 11.6584L13.0125 12.4472C13.0819 12.4819 13.1584 12.5 13.2361 12.5H16C16.2761 12.5 16.5 12.2761 16.5 12V7C16.5 6.72386 16.2761 6.5 16 6.5H13.2361C13.0032 6.5 12.7735 6.44578 12.5652 6.34164L10.9875 5.55279C10.9181 5.51807 10.8416 5.5 10.7639 5.5H7.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const StartExecutionPlayIcon = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 5.86852C7 4.67048 8.33522 3.95589 9.33205 4.62044L18.5293 10.7519C19.4199 11.3457 19.4199 12.6543 18.5293 13.2481L9.33205 19.3796C8.33522 20.0441 7 19.3295 7 18.1315V5.86852ZM8.77735 5.45249C8.44507 5.23098 8 5.46917 8 5.86852V18.1315C8 18.5308 8.44507 18.769 8.77735 18.5475L17.9746 12.416C18.2714 12.2181 18.2714 11.7819 17.9746 11.584L8.77735 5.45249Z"
        fill={fillColor}
      />
    </svg>
  );
};

const XIcon = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.64645 6.64645C6.84171 6.45118 7.15829 6.45118 7.35355 6.64645L12 11.2929L16.6464 6.64645C16.8417 6.45118 17.1583 6.45118 17.3536 6.64645C17.5488 6.84171 17.5488 7.15829 17.3536 7.35355L12.7071 12L17.3536 16.6464C17.5488 16.8417 17.5488 17.1583 17.3536 17.3536C17.1583 17.5488 16.8417 17.5488 16.6464 17.3536L12 12.7071L7.35355 17.3536C7.15829 17.5488 6.84171 17.5488 6.64645 17.3536C6.45118 17.1583 6.45118 16.8417 6.64645 16.6464L11.2929 12L6.64645 7.35355C6.45118 7.15829 6.45118 6.84171 6.64645 6.64645Z"
        fill={fillColor}
      />
    </svg>
  );
};

const MessageIcon = ({ fillColor, height, width }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 4.5C3.5 4.22386 3.72386 4 4 4H12C12.2761 4 12.5 4.22386 12.5 4.5C12.5 4.77614 12.2761 5 12 5H4C3.72386 5 3.5 4.77614 3.5 4.5Z"
        fill={fillColor}
      />
      <path
        d="M4 7C3.72386 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.72386 8 4 8H8C8.27614 8 8.5 7.77614 8.5 7.5C8.5 7.22386 8.27614 7 8 7H4Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 2C0.5 0.89543 1.39543 0 2.5 0H13.5C14.6046 0 15.5 0.895431 15.5 2V10C15.5 11.1046 14.6046 12 13.5 12H5.62132C5.3561 12 5.10175 12.1054 4.91421 12.2929L3.06066 14.1464C2.11571 15.0914 0.5 14.4221 0.5 13.0858V2ZM2.5 1C1.94772 1 1.5 1.44772 1.5 2V13.0858C1.5 13.5312 2.03857 13.7543 2.35355 13.4393L4.20711 11.5858C4.58218 11.2107 5.09089 11 5.62132 11H13.5C14.0523 11 14.5 10.5523 14.5 10V2C14.5 1.44772 14.0523 1 13.5 1H2.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const PhoneIcon = ({ fillColor, height, width }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.31 4.395C3.03 5.81 4.19 6.97 5.605 7.69L6.705 6.59C6.845 6.45 7.04 6.41 7.215 6.465C7.775 6.65 8.375 6.75 9 6.75C9.13261 6.75 9.25979 6.80268 9.35355 6.89645C9.44732 6.99021 9.5 7.11739 9.5 7.25V9C9.5 9.13261 9.44732 9.25979 9.35355 9.35355C9.25979 9.44732 9.13261 9.5 9 9.5C6.74566 9.5 4.58365 8.60447 2.98959 7.01041C1.39553 5.41635 0.5 3.25434 0.5 1C0.5 0.867392 0.552678 0.740215 0.646447 0.646447C0.740215 0.552678 0.867392 0.5 1 0.5H2.75C2.88261 0.5 3.00979 0.552678 3.10355 0.646447C3.19732 0.740215 3.25 0.867392 3.25 1C3.25 1.625 3.35 2.225 3.535 2.785C3.59 2.96 3.55 3.155 3.41 3.295L2.31 4.395Z"
        fill={fillColor}
      />
    </svg>
  );
};

const BotIcon = ({ fillColor, height, width }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.77355 0.805833C5.77355 0.472474 5.52963 0.30654 5.47078 0.269094C5.38205 0.212637 5.28889 0.180317 5.22457 0.161005C5.08749 0.11985 4.91925 0.0914515 4.75109 0.0704994C4.40633 0.027542 3.9613 0.00411275 3.52588 0.000495735C3.09126 -0.00311458 2.64335 0.0128099 2.29449 0.0543461C2.12496 0.0745317 1.95014 0.103914 1.80545 0.151132C1.73671 0.173565 1.63667 0.211865 1.54268 0.280317C1.45631 0.343215 1.26904 0.512851 1.26906 0.805858V2.43384C1.26906 2.69299 1.41431 2.86291 1.51289 2.94534C1.6086 3.02538 1.71278 3.07097 1.786 3.09791C1.93754 3.15366 2.11858 3.18662 2.29001 3.20846C2.64355 3.25349 3.09511 3.26741 3.53047 3.26018C3.96743 3.25292 4.41322 3.2239 4.75855 3.17609C4.92709 3.15276 5.09521 3.12186 5.23204 3.07867C5.29638 3.05836 5.38862 3.02484 5.47615 2.96774C5.53344 2.93037 5.77355 2.76401 5.77355 2.43384V2.22501C5.91526 2.21327 6.07746 2.20165 6.24746 2.1929C6.5111 2.17932 6.78577 2.17306 7.02835 2.18267C7.27827 2.19257 7.44688 2.21804 7.53205 2.24577C7.53205 2.24577 7.53265 2.24706 7.5352 2.24918C7.55032 2.26176 7.61127 2.31244 7.70242 2.46277C7.814 2.6468 7.92685 2.90777 8.02764 3.22246C8.13041 3.54334 8.21311 3.8961 8.26956 4.24132C7.18344 4.2674 6.12587 4.32999 5.22991 4.42721C4.6587 4.48918 4.14277 4.56633 3.72254 4.65996C3.3305 4.74729 2.93313 4.86656 2.67094 5.05686C2.36882 5.27618 2.1882 5.62811 2.07116 5.95474C1.98302 6.20071 1.91426 6.48041 1.86058 6.77959L1.60776 6.81549L1.60663 6.81564L1.6048 6.81592L1.60005 6.81663L1.58635 6.81872C1.57542 6.82044 1.56089 6.82284 1.54327 6.82594C1.50815 6.83209 1.46005 6.84122 1.40312 6.85379C1.29186 6.87838 1.13488 6.91871 0.970661 6.98086C0.81508 7.03979 0.605546 7.13566 0.422135 7.29194C0.235142 7.45126 -0.000111689 7.74334 3.97826e-08 8.17374C0.000119309 8.63258 4.70956e-05 12.2584 3.97826e-08 12.7633C-3.97574e-05 13.1915 0.221475 13.4942 0.446709 13.67C0.651156 13.8297 0.881281 13.9084 1.0439 13.9507C1.21693 13.9958 1.38068 14.0163 1.49497 14.0262C1.55375 14.0313 1.60342 14.0339 1.63978 14.0353C1.65803 14.036 1.67314 14.0363 1.6846 14.0365L1.69906 14.0367L1.70416 14.0368H2.08985C2.19775 14.6109 2.32604 15.1056 2.47347 15.4345C2.57781 15.6672 2.75346 15.834 2.91844 15.9524C3.08795 16.0741 3.28749 16.1741 3.4972 16.2584C3.91667 16.4271 4.44793 16.5609 5.03424 16.6662C6.21183 16.8777 7.70143 16.9896 9.17155 16.9993C10.6407 17.009 12.1198 16.917 13.2746 16.7094C13.8487 16.6062 14.3709 16.4696 14.7787 16.288C14.9829 16.1971 15.18 16.0854 15.3445 15.9442C15.5085 15.8033 15.6697 15.6071 15.7422 15.3439C15.8312 15.0209 15.92 14.5391 16.0009 13.9601H16.2926H16.2958L16.3009 13.96L16.3154 13.9599C16.3268 13.9596 16.342 13.9593 16.3602 13.9586C16.3966 13.9572 16.4463 13.9546 16.505 13.9495C16.6193 13.9396 16.7831 13.9191 16.9561 13.874C17.1187 13.8317 17.3488 13.753 17.5533 13.5934C17.7785 13.4175 18 13.1148 18 12.6867C17.9999 12.1817 17.9999 8.55589 18 8.09705C18.0001 7.66668 17.7648 7.37457 17.5779 7.21525C17.3944 7.05897 17.1849 6.9631 17.0293 6.9042C16.8651 6.84202 16.7081 6.80169 16.5969 6.77713C16.54 6.76455 16.4918 6.75542 16.4567 6.74925C16.4391 6.74614 16.4246 6.74374 16.4136 6.74202L16.3999 6.73993L16.3952 6.73923L16.3934 6.73895L16.3919 6.73876L16.1918 6.71033C16.1543 6.46371 16.1076 6.23274 16.0498 6.02517C15.961 5.70659 15.8242 5.36047 15.5855 5.11966C15.4443 4.97716 15.267 4.88221 15.1096 4.8151C14.944 4.7444 14.7539 4.68539 14.5513 4.63485C14.1458 4.53375 13.6424 4.45506 13.0844 4.39475C12.0271 4.28046 10.7227 4.22687 9.40646 4.22744C9.34073 3.76506 9.23368 3.29134 9.09752 2.86622C8.98031 2.50024 8.83428 2.1472 8.65973 1.85932C8.49876 1.59383 8.25359 1.28255 7.89741 1.16026C7.65347 1.0765 7.34733 1.04686 7.07205 1.03595C6.78325 1.02451 6.47204 1.03229 6.19068 1.04678C6.04327 1.05437 5.90192 1.06392 5.77355 1.07388V0.805833ZM3.9696 5.86228C3.57791 5.94958 3.39403 6.03082 3.34623 6.06553C3.34623 6.06553 3.32453 6.08308 3.29171 6.13564C3.25743 6.19057 3.21799 6.27154 3.17749 6.38456C3.09578 6.61264 3.02596 6.92489 2.97318 7.31306C2.86794 8.08715 2.84149 9.07722 2.87531 10.1081C2.90902 11.1353 3.00181 12.1813 3.12751 13.0601C3.25404 13.9448 3.40504 14.5928 3.53543 14.8961C3.54261 14.9034 3.55861 14.9185 3.5886 14.9401C3.65626 14.9886 3.7644 15.0478 3.92263 15.1115C4.23903 15.2387 4.68474 15.3558 5.23492 15.4546C6.33033 15.6513 7.75194 15.7603 9.17907 15.7698C10.6072 15.7793 12.0113 15.6888 13.0737 15.4978C13.6083 15.4017 14.0281 15.285 14.3143 15.1575C14.4572 15.0939 14.545 15.037 14.5933 14.9955C14.6033 14.9869 14.6104 14.9801 14.6152 14.975C14.8254 14.1824 15.0702 12.1221 15.1366 10.0938C15.17 9.07525 15.1571 8.09564 15.0777 7.31908C15.0379 6.92987 14.983 6.60932 14.9157 6.36778C14.8823 6.24771 14.8485 6.15734 14.8175 6.09261C14.8022 6.06079 14.789 6.0382 14.7789 6.02289C14.7737 6.01514 14.7698 6.00992 14.7672 6.00672C14.7591 6.00138 14.7281 5.98106 14.6619 5.95284C14.5711 5.91408 14.4436 5.87233 14.2763 5.83059C13.9417 5.74716 13.4954 5.67533 12.9625 5.61772C11.8996 5.50282 10.5492 5.4505 9.18212 5.45764C7.81565 5.46477 6.44818 5.53122 5.3523 5.65015C4.80342 5.70969 4.33312 5.78131 3.9696 5.86228Z"
        fill={fillColor}
      />
      <path
        d="M11.7213 11.9472C12.7811 11.9472 13.6402 11.0526 13.6402 9.94913C13.6402 8.84566 12.7811 7.95111 11.7213 7.95111C10.6616 7.95111 9.80247 8.84566 9.80247 9.94913C9.80247 11.0526 10.6616 11.9472 11.7213 11.9472Z"
        fill={fillColor}
      />
      <path
        d="M8.03121 9.94913C8.03121 11.0526 7.17211 11.9472 6.11235 11.9472C5.05259 11.9472 4.19348 11.0526 4.19348 9.94913C4.19348 8.84566 5.05259 7.95111 6.11235 7.95111C7.17211 7.95111 8.03121 8.84566 8.03121 9.94913Z"
        fill={fillColor}
      />
    </svg>
  );
};

const ReloadIcon = ({ fillColor, height, width }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.14645 3.64645C8.95118 3.84171 8.95118 4.15829 9.14645 4.35355L10.3273 5.53439C7.05352 5.871 4.5 8.6373 4.5 12C4.5 14.6241 6.05489 16.8839 8.29144 17.9104C8.54241 18.0256 8.83924 17.9155 8.95442 17.6645C9.06961 17.4136 8.95954 17.1167 8.70856 17.0015C6.81405 16.132 5.5 14.2189 5.5 12C5.5 9.21997 7.56258 6.92168 10.2409 6.55195L9.14645 7.64645C8.95118 7.84171 8.95118 8.15829 9.14645 8.35355C9.34171 8.54882 9.65829 8.54882 9.85355 8.35355L11.8536 6.35355C12.0488 6.15829 12.0488 5.84171 11.8536 5.64645L9.85355 3.64645C9.65829 3.45118 9.34171 3.45118 9.14645 3.64645Z"
        fill={fillColor}
      />
      <path
        d="M14.8536 15.8095L13.7591 16.904C16.4374 16.5343 18.5 14.236 18.5 11.456C18.5 9.23702 17.186 7.32394 15.2914 6.45442C15.0405 6.33924 14.9304 6.04241 15.0456 5.79143C15.1608 5.54046 15.4576 5.43039 15.7086 5.54558C17.9451 6.57207 19.5 8.83191 19.5 11.456C19.5 14.8187 16.9465 17.585 13.6727 17.9216L14.8536 19.1024C15.0488 19.2977 15.0488 19.6142 14.8536 19.8095C14.6583 20.0048 14.3417 20.0048 14.1464 19.8095L12.1464 17.8095C11.9512 17.6142 11.9512 17.2977 12.1464 17.1024L14.1464 15.1024C14.3417 14.9071 14.6583 14.9071 14.8536 15.1024C15.0488 15.2977 15.0488 15.6142 14.8536 15.8095Z"
        fill={fillColor}
      />
    </svg>
  );
};

const ClockMagicIcon = ({ fillColor, height, width }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6121 10.6552C15.8025 10.8551 15.7948 11.1716 15.5948 11.3621L13.725 13.1429L16.3448 15.6379C16.5448 15.8284 16.5525 16.1449 16.3621 16.3448C16.1716 16.5448 15.8551 16.5525 15.6552 16.3621L12.7692 13.6135C12.5003 13.3574 12.5003 12.9283 12.7692 12.6722L14.9052 10.6379C15.1051 10.4475 15.4216 10.4552 15.6121 10.6552Z"
        fill={fillColor}
      />
      <path
        d="M2.17048 10.2153C1.94452 10.1749 1.94261 9.83872 2.16817 9.79639C5.56281 9.15938 5.94033 8.31596 6.73304 5.14723C6.7825 4.94952 7.08699 4.95167 7.13702 5.14925C7.94161 8.32742 8.89754 9.1654 11.8384 9.80308C12.0553 9.85012 12.0533 10.1643 11.8358 10.2092C8.90314 10.8153 7.94108 11.6876 7.09673 14.8531C7.04386 15.0513 6.73603 15.0482 6.69084 14.8483C5.97853 11.6972 5.56156 10.8208 2.17048 10.2153Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.66571 6.28013C9.34931 6.43743 9.04559 6.61641 8.75651 6.81514C8.93019 7.16741 9.11393 7.43228 9.31628 7.64394C9.69281 7.38448 10.0981 7.16369 10.5263 6.98732C10.4559 6.80514 10.3897 6.69551 10.3164 6.61375C10.2279 6.51496 10.073 6.39976 9.66571 6.28013ZM13.8349 6.55316C17.0305 6.9629 19.5 9.69307 19.5 13C19.5 16.5899 16.5899 19.5 13 19.5C10.475 19.5 8.28628 18.0603 7.20998 15.9569C7.09649 15.9874 6.98385 16.0011 6.87987 16C6.57496 15.9966 6.19555 15.8628 5.94592 15.5535C6.99045 18.4385 9.7545 20.5 13 20.5C17.1422 20.5 20.5 17.1422 20.5 13C20.5 9.74151 18.422 6.96835 15.5188 5.93347C15.4017 6.01241 15.2633 6.07193 15.1039 6.10488C14.4184 6.24655 14.0606 6.39022 13.8349 6.55316Z"
        fill={fillColor}
      />
      <path
        d="M9.10229 5.12915C8.96671 5.10494 8.96557 4.90323 9.1009 4.87784C11.1377 4.49563 11.3642 3.98958 11.8398 2.08834C11.8695 1.96971 12.0522 1.971 12.0822 2.08955C12.565 3.99645 13.1385 4.49924 14.903 4.88185C15.0332 4.91007 15.032 5.09857 14.9015 5.12554C13.1419 5.48921 12.5646 6.01257 12.058 7.91185C12.0263 8.03078 11.8416 8.02892 11.8145 7.90897C11.3871 6.01832 11.1369 5.4925 9.10229 5.12915Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ThemedMailIcon = iconThemeColor(MailIcon);
export const ThemedCheckIcon = iconThemeColor(CheckIcon);
export const ThemedInfoIcon = iconThemeColor(InfoIcon);
export const ThemedFlagIcon = iconThemeColor(FlagIcon);
export const ThemedStartExecutionPlayIcon = iconThemeColor(StartExecutionPlayIcon);
export const ThemedXIcon = iconThemeColor(XIcon);
export const ThemedMessageIcon = iconThemeColor(MessageIcon);
export const ThemedBotIcon = iconThemeColor(BotIcon);
export const ThemedPhoneIcon = iconThemeColor(PhoneIcon);
export const ThemedReloadIcon = iconThemeColor(ReloadIcon);
export const ThemedClockMagicIcon = iconThemeColor(ClockMagicIcon);
